import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { News } from '../../shared/interface';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrl: './news.component.css',
  encapsulation: ViewEncapsulation.None
})
export class NewsComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  news: News[] = [];    
  news_filtrate: News[] = [];

  ngOnInit(): void {    

    this.apiService.getNotizie().subscribe({
      next: (data) => this.news = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {              
        this.updatePaginatedItems(0, 8);
      }
    })

  }

  onPageChange(event: any, element: HTMLElement) {
    this.updatePaginatedItems(event.first, event.rows);
    element.scrollIntoView({ behavior: 'smooth' });
  }

  updatePaginatedItems(startIndex: number, endIndex: number) {    
    this.news_filtrate = [...this.news.slice(startIndex, startIndex + endIndex)];
  }
}
